import { breakpoint, colors, fontFamily, mediaQueryHelper, shorthandHelper, spacing } from '@offerzen/pinata'
import { css } from '@emotion/css'

const styles = {
  candidateContainer: css({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    fontFamily: fontFamily.body,
    padding: shorthandHelper([40, spacing.large, spacing.extraLarge]),
    backgroundColor: colors.catskillWhite,
    alignItems: 'center',

    [mediaQueryHelper(breakpoint.phone)]: {
      padding: '60px 40px 220px 40px',
    },
  }),

  candidateCard: css({
    margin: 'auto',
  }),

  footerContainer: css({
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    width: '100%',
  }),

  mobileOnly: css({
    display: 'flex',
    width: '100%',
  }),

  errorNotification: css({
    width: 'auto',

    [mediaQueryHelper(breakpoint.phone)]: {
      width: '100%',
      maxWidth: 791,
    },
  }),
}

export default styles
